<Box
  align="left"
  py="3px" pl="sm" pr="xs"
  mr="2px" mb="2px"
  border="5"
  rounded="xs"
  vertical="top"
  noflex
  noitems="center"
  nojustify="between"
  line="1"
  >

  <Label 
    sm 
    color="dark" 
    h="1.05" line="1"
    >
    {#if label !== ''}
      {label}
    {:else}
      <slot></slot>
    {/if}
  </Label>

  <Icon 
    on:click={() => emit('delete')}
    name="close" 
    size="md" h=1 
    color="body"
    ml="sm" mt="-2px"
    round
    pointer
    hover
    /> 

</Box>


<script>
  import { createEventDispatcher } from 'svelte';
  import { Box, Icon, Panel, Label, Text } from 'svelte-stylo';
  
	const emit = createEventDispatcher();  

  export let 
    wide = true,
    label = '';

</script>
